/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
export var groupItemStyles = {
    flex: '1 0 auto',
    display: 'flex',
    /* margins don't flip when the layout uses dir="rtl", whereas pseudos do */
    '& + &::before': {
        content: "''",
        display: 'inline-block',
        width: gridSize() / 2 + "px",
    },
};
export default function ButtonGroup(_a) {
    var appearance = _a.appearance, children = _a.children;
    return (jsx("div", { css: { display: 'inline-flex' } }, React.Children.map(children, function (child, idx) {
        if (!child) {
            return null;
        }
        return (jsx("div", { key: idx, css: groupItemStyles }, appearance
            ? React.cloneElement(child, { appearance: appearance })
            : child));
    })));
}
//# sourceMappingURL=button-group.js.map